import React, { ReactElement, useEffect } from "react";
import styles from "./ControlledModal.module.scss";
import { Button, ButtonVariant } from "@src/components/button/Button";
import XIconThemed from "@src/assets/general-icons/XIconThemed";
import { clx } from "@src/components/utils/stringUtils";
import { useModalDrag } from "./useModalDrag";

interface IModalProps {
	isOpen: boolean;
	onClose?: (proceed: boolean) => void;
	headerText?: string;
	title?: string;
	content?: ReactElement | string;
	cancelButtonText: string;
	okButtonText: string;
	isDraggable?: boolean;
}

const ControlledModal: React.FC<IModalProps> = ({
	isOpen,
	onClose,
	headerText,
	title,
	content,
	okButtonText,
	cancelButtonText,
	isDraggable = true,
}) => {
	const { contentRef, dragProps, resetPosition } = useModalDrag(isDraggable);

	useEffect(() => {
		if (!isOpen) resetPosition();
	}, [isOpen, resetPosition]);

	return (
		<>
			{isOpen && (
				<div className={styles.overlay}>
					<div ref={contentRef} className={styles.contentContainer} {...dragProps}>
						<div data-modal-drag-handle className={clx(styles.header, isDraggable ? styles.draggable : "")}>
							{headerText}
							<div className={styles.iconContainer} data-no-drag aria-hidden onClick={() => onClose?.(false)}>
								<XIconThemed color="#fafafa" />
							</div>
						</div>
						<div className={styles.content}>
							<div className={styles.title}>{title}</div>
							<div className={styles.description}>{content}</div>
						</div>
						<div className={styles.buttonsContainer}>
							<Button className={styles.button} variant={ButtonVariant.Secondary} onClick={() => onClose?.(false)}>
								{cancelButtonText}
							</Button>
							<Button className={styles.button} variant={ButtonVariant.Primary} onClick={() => onClose?.(true)}>
								{okButtonText}
							</Button>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default ControlledModal;
